import { Grid } from "@scuf/common";
import React from "react";
import Alertas from "./APC-Alertas";
import Aplicaciones from "./APC-Aplicaciones";
import EstadoProfit from "./APC-Estado-Profit";
import GraficosUtilizacion from "./APC-Graficos-Utilizacion";
import Indicadores from "./APC-Indicadores";

import "./APC.css";

const APC = () => {
  return (
    <>
      <Grid className="m-0 p-0">
        {/** Componente de APC. Barra principal (superior) */}
        <Indicadores />

        <Grid.Row>
          <Grid.Column
            xsWidth="12"
            sWidth="6"
            mWidth="6"
            lWidth="6"
            xlWidth="6"
          >
            {/** Componente (Carousel) de graficos de APC (Lado izquierdo superior) */}
            <GraficosUtilizacion />

            {/** Componente (Carousel) de graficos de APC (Lado izquierdo inferior) */}
            <Aplicaciones />
          </Grid.Column>

          <Grid.Column
            xsWidth="12"
            sWidth="6"
            mWidth="6"
            lWidth="6"
            xlWidth="6"
          >
            {/** Componente (Carousel) de graficos de APC (Lado derecho superior) */}
            <EstadoProfit />
            {/** Componente (Carousel) de graficos de APC (Lado derecho inferior) */}
            <Alertas />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </>
  );
};

export default APC;
